module.exports = __webpack_public_path__ + "static/media/img-datos-personales.45777c93.png";